/**
 * @file   src\components\LocationPermissionFetch.tsx
 * @brief  LocationPermissionFetch component.
 * @date   OCT, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { useGeolocated } from "react-geolocated";

const LocationPermissionFetch = (props: any) => {
    
    const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
        positionOptions: {
          enableHighAccuracy: true,
          maximumAge: 0,
          timeout: Infinity,
      },
      watchPosition: false,
      suppressLocationOnMount: false,
      geolocationProvider: navigator.geolocation,
      isOptimisticGeolocationEnabled: true,
      watchLocationPermissionChange: false,
  });

    if(coords && isGeolocationEnabled ) {
       localStorage.setItem('geolocation',JSON.stringify({ lat: coords.latitude, long: coords.longitude }))
       localStorage.setItem('locationPermissionGranted', 'true');
        localStorage.removeItem('locationPermissionDenied'); 
        props.onAllow()
    }
};
export default LocationPermissionFetch;
